import { Text, Field, Item, getFieldValue, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import classNames from 'classnames/bind';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

import CustomIconBulletedListItem, {
  type CustomIconBulletedListItemProps,
} from 'components/CustomIconBulletedList/CustomIconBulletedListItem';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';
import { RecordOfFields } from 'models/fields';

import styles from './CustomIconBulletedList.module.scss';

type CustomIconBulletedListProps = ComponentProps & {
  fields: {
    backgroundColor: Item;
    heading: Field<string>;
    headingLevel: Item;
    textStyles: Item;
    children: CustomIconBulletedListItemProps[];
  };
};

const cx = classNames.bind(styles);

const CustomIconBulletedList = (props: CustomIconBulletedListProps): React.JSX.Element => {
  const { fields, className } = props;
  const bgColor = fields?.backgroundColor?.fields as RecordOfFields;
  const { sitecoreContext } = useSitecoreContext();

  const headingLevelItemField = fields?.headingLevel?.fields as RecordOfFields;
  const headingLevelValue = getFieldValue<string>(headingLevelItemField, 'Value') || 'h3';

  const headingTextStyleItemField = fields?.textStyles?.fields as RecordOfFields;
  const headingTextStyleValue = getFieldValue<string>(headingTextStyleItemField, 'Value') || 'font-style-xl';

  if (!sitecoreContext.pageEditing && !fields?.children?.length) {
    return <></>;
  }

  return (
    <div className={cx('iconBulletedList', className, `${getFieldValue(bgColor, 'Value')}`)}>
      {sitecoreContext.pageEditing || fields?.heading?.value.length ? (
        <Text
          className={cx(headingTextStyleValue)}
          field={fields?.heading}
          encode={sitecoreContext.pageEditing}
          tag={headingLevelValue}
        />
      ) : null}
      <ul className={cx('iconBulletedList__list')}>
        {fields?.children?.map((childProps: CustomIconBulletedListItemProps) => {
          const { id, ...rest } = childProps;
          return <CustomIconBulletedListItem id={id} key={`bulleted-list-key-${id}`} {...rest} />;
        })}
      </ul>
    </div>
  );
};

export default compose<CustomIconBulletedListProps>(withValidDatasourceCheck(), withStyles())(CustomIconBulletedList);
